/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { defineComponent, inject, createVNode, mergeProps, Fragment } from 'vue';
import { LayoutEnum } from '../common.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { descriptionsKey } from './const/index.mjs';
import { itemTypeIsProps, renderVNodeTNode } from './utils/index.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import './interface.mjs';

var DescriptionsRow = defineComponent({
  name: "TDescriptionsRow",
  props: {
    row: Array,
    itemType: String
  },
  setup: function setup(props) {
    var descriptionsProps = inject(descriptionsKey);
    var COMPONENT_NAME = usePrefixClass("descriptions");
    var label = function label(node) {
      var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LayoutEnum.HORIZONTAL;
      var labelClass = ["".concat(COMPONENT_NAME.value, "__label")];
      var label2 = null;
      var span = null;
      if (itemTypeIsProps(props.itemType, node)) {
        label2 = node.label;
        span = node.span;
      } else {
        label2 = renderVNodeTNode(node, "label");
        span = node.props.span;
      }
      var labelSpan = layout === LayoutEnum.HORIZONTAL ? 1 : span;
      return createVNode("td", mergeProps({
        "colspan": labelSpan,
        "class": labelClass
      }, {
        style: descriptionsProps.labelStyle
      }), [label2, descriptionsProps.colon && ":"]);
    };
    var content = function content(node) {
      var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LayoutEnum.HORIZONTAL;
      var contentClass = ["".concat(COMPONENT_NAME.value, "__content")];
      var content2 = null;
      var span = null;
      if (itemTypeIsProps(props.itemType, node)) {
        content2 = node.content;
        span = node.span;
      } else {
        content2 = renderVNodeTNode(node, "content", "default");
        span = node.props.span;
      }
      var contentSpan = span > 1 && layout === LayoutEnum.HORIZONTAL ? span * 2 - 1 : span;
      return createVNode("td", mergeProps({
        "colspan": contentSpan,
        "class": contentClass
      }, {
        style: descriptionsProps.contentStyle
      }), [content2]);
    };
    var hh = function hh() {
      return createVNode("tr", null, [props.row.map(function (node) {
        return createVNode(Fragment, null, [label(node), content(node)]);
      })]);
    };
    var hv = function hv() {
      return createVNode(Fragment, null, [createVNode("tr", null, [props.row.map(function (node) {
        return label(node, LayoutEnum.VERTICAL);
      })]), createVNode("tr", null, [props.row.map(function (node) {
        return content(node, LayoutEnum.VERTICAL);
      })])]);
    };
    var vh = function vh() {
      return createVNode(Fragment, null, [props.row.map(function (node) {
        return createVNode("tr", null, [label(node), content(node)]);
      })]);
    };
    var vv = function vv() {
      return createVNode(Fragment, null, [props.row.map(function (node) {
        return createVNode(Fragment, null, [createVNode("tr", null, [label(node)]), createVNode("tr", null, [content(node)])]);
      })]);
    };
    return function () {
      return createVNode(Fragment, null, [descriptionsProps.layout === LayoutEnum.HORIZONTAL ? descriptionsProps.itemLayout === LayoutEnum.HORIZONTAL ? hh() : hv() : descriptionsProps.itemLayout === LayoutEnum.HORIZONTAL ? vh() : vv()]);
    };
  }
});

export { DescriptionsRow as default };
//# sourceMappingURL=descriptions-row.mjs.map
